/* eslint-disable no-mixed-spaces-and-tabs */
<template>
  <div
    class="content has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >
    <div class="columns">
      <div class="column is-half">
        <article class="message is-danger">
          <div
            class="message-body"
            v-html="$t('change_password_desc')"
          ></div>
        </article>

        <div class="field">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="oldPassword"
          >{{$t('current_password').tUpper()}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('oldPassword') }"
              name="oldPassword"
              type="password"
              :data-vv-as="$t('current_password').tCapitalizeFirstLetter()"
              :placeholder="$t('current_password').tCapitalizeFirstLetter()"
              v-model="changePassword.old"
            />
            <span
              v-show="errors.has('oldPassword')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('oldPassword') }}</span>
          </p>
        </div>

        <div class="field">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="newPassword"
          >{{$t('new_password').tUpper()}}</label>
          <p class="control">
            <input
              v-validate="'required|strong-password|confirmed:newPasswordConfirm'"
              :class="{'input': true, 'is-danger': errors.has('newPassword') }"
              name="newPassword"
              type="password"
              :data-vv-as="$t('new_password').tCapitalizeFirstLetter()"
              :placeholder="$t('new_password').tCapitalizeFirstLetter()"
              v-model="changePassword.new"
            />
            <span
              v-show="errors.has('newPassword')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('newPassword') }}</span>
          </p>
        </div>
        <div class="field">
          <label
            class="label"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            for="newPasswordConfirm"
          >{{$t('confirm_new_password').tUpper()}}</label>
          <p class="control">
            <input
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('newPasswordConfirm') }"
              name="newPasswordConfirm"
              type="password"
              :data-vv-as="$t('confirm_new_password').tCapitalizeFirstLetter()"
              :placeholder="$t('confirm_new_password').tCapitalizeFirstLetter()"
              v-model="changePassword.newConfirm"
              ref="newPasswordConfirm"
            />
            <span
              v-show="errors.has('newPasswordConfirm')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('newPasswordConfirm') }}</span>
          </p>
        </div>

        <button
          class="button is-primary is-pulled-right"
          @click="ChangePassword()"
        >{{$t('change_password').tUpper()}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../app'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      changePassword: {
        old: '',
        new: '',
        newConfirm: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      User: 'user/all',
    }),
  },
  mounted() {},
  methods: {
    ChangePassword() {
      this.$validator.validateAll().then(() => {
        service
          .post('/users/change-password', {
            newPassword: this.changePassword.new,
            newPasswordConfirm: this.changePassword.newConfirm,
            oldPassword: this.changePassword.old,
            userID: this.User.info.ID,
          })
          .then(response => {
            if (response.data.success) {
              this.$router.push('/' + this.Language + '/profile')
              this.$toasted.success(this.$t('changepass_success'))
            }
          })
          .catch(error => {
            if (typeof error.response.data !== 'undefined') {
              if (this.Language === 'fa') {
                this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>', { duration: 10000, position: 'top-left' })
              } else {
                this.$toasted.error(error.response.data.detail + '<span class="error-id">' + error.response.data.id + '</span>', { duration: 10000 })
              }
            }
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "../assets/css/variables";
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?d2a70590